<template>
  <List :mapState="'restaurantProducts'" :allDispatch="'restaurantProductsAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/restaurant/products/list.vue